export default __webpack_public_path__ + "move-option.png";